Vue.asyncComponent('bp-tab-navigation', {
}, 'blueprints/utils/tabs/bp-tab-navigation.html');